import { render, staticRenderFns } from "./AddToCartForm.vue?vue&type=template&id=0680a59b&"
import script from "./AddToCartForm.js?vue&type=script&lang=js&"
export * from "./AddToCartForm.js?vue&type=script&lang=js&"
import style0 from "./AddToCartForm.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AddToCartForm.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fproductdetail%2FAddToCartForm%2FAddToCartForm.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports